import { Routes, Route, Navigate } from "react-router-dom";
import { GlobalLayout, ProtectedLayout, PageNotFound } from "@components/index";
import { ProtectedLayout as PCProtectedLayout } from "../../PanelContract/Components/Layout/ProtectedLayout";

import { protectRoutes, globalRoutes } from "./Routes";
import { protectRoutes as pcProtectRoutes } from "../../PanelContract/Routes/Routes";
import { ReactNode } from "react";
import { useHasAccess } from "@hooks/useHasAccess";
import { useAuth } from "~/Hooks/useAuth";
import { InactivityDetector } from "../Utils/InactivityDetector";
import { defaultRedirect, UserType } from "@utils/Constants";
import { isEmpty } from "lodash";
import { useHasPanelAccess } from "../../PanelContract/Hooks/useHasAccess";

export function GlobalRouter() {
  const { user } = useAuth();
  const { hasRole } = useHasAccess();
  const { getPanelUser, hasPanelRole } = useHasPanelAccess();

  const getElementwithAccess = (element: ReactNode, roles: string[]) => {
    if (!user) {
      return <Navigate to="/auth/login" />;
    } else {
      return hasRole(roles) ? (
        <InactivityDetector>{element}</InactivityDetector>
      ) : (
        <Navigate to="/unauthorized-entry" />
      );
    }
  };

  /**
   * Panel Contract routes are gated on the PANEL role, not the ePOD one.
   *
   * They were mounted with the ePOD guard and `roles: ["*"]`, which let any
   * signed-in user open every panel screen — so a Work Order Approver reached
   * the admin-only screens and was bounced to the 403 page.
   */
  const getPanelElementWithAccess = (element: ReactNode, roles: string[]) => {
    if (!user || !getPanelUser()) {
      return <Navigate to="/auth/login" />;
    }
    return hasPanelRole(roles) ? (
      <InactivityDetector>{element}</InactivityDetector>
    ) : (
      <Navigate to="/unauthorized-entry" />
    );
  };
  return (
    <Routes>
      {/* Replace this with error pages */}
      {/*temporary fix have to change these bac*/}
      <Route
        path="*"
        element={<Navigate to={"/auth/login"} />}
      />
      <Route
        path="/"
        element={<Navigate to={"/auth/login"} />}
      />
      <Route element={<ProtectedLayout />}>
        {protectRoutes.map(({ path, element, roles }) => {
          return (
            <Route
              path={path}
              element={getElementwithAccess(element, roles)}
              key={path}
            />
          );
        })}
      </Route>
      <Route element={<PCProtectedLayout />}>
        {pcProtectRoutes.map(({ path, element, roles }) => {
          return (
            <Route
              path={path}
              element={getPanelElementWithAccess(element, roles)}
              key={path}
            />
          );
        })}
      </Route>
      <Route element={<GlobalLayout />}>        
        {globalRoutes.map(({ path, element, ...res }) => {
          let defaultUrl = `/dashboard`;
          // let defaultUrl = user && user?.role == "SUPER_ADMIN" ? `/pcd-dashboard` : user.role != null ? `/${UserType[user?.role as keyof typeof UserType]}-dashboard` : '/auth/login'
          // let defaultUrl = `/`;
          const queryParams = new URLSearchParams(window.location.search);
          const redirectTo: any = queryParams.get("redirect");
          // let redirectTo = localStorage.getItem("redirectTo");
          if (
            !isEmpty(redirectTo) &&
            redirectTo !== "null" &&
            redirectTo?.startsWith("/") &&
            user &&
            user?.role != null
          ) {
            defaultUrl = redirectTo;
            // localStorage.removeItem("redirectTo");
          }
          return (
            <Route
              path={path}
              {...res}
              element={
                user && user?.token && (["/auth/login"].includes(path) || path.includes("?redirect=")) ? (
                  <Navigate to={defaultUrl} />
                ) : (
                  element
                )
              }
              // element={element}
              key={path}
            />
          );
        })}
      </Route>
    </Routes>
  );
}
